import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";

interface IProps {
  className?: string;
  title: string | JSX.Element | undefined;
  subtitle?: string | JSX.Element;
}

export const Title: React.FC<IProps> = ({ className, title, subtitle }) => {
  return (
    <Wrapper className={className} $useUpdatedSpacing={isLoggedInRetailer()}>
      {typeof title === "string" ? (
        /* For SEO purpose, we have to make this h1 tag, please don't change unless consulted with the SEO team */
        <Typography
          variant="displaySSerifRegular"
          as="h1"
          data-test-id="catnav-title"
        >
          {title}
        </Typography>
      ) : (
        title
      )}
      {typeof subtitle === "string" ? (
        <>
          <Spacer size="1x" />
          {/* For SEO purpose, we have to make this h2 tag, please don't change unless consulted with the SEO team */}
          <Typography as="h2" data-test-id="catnav-subtitle">
            {subtitle}
          </Typography>
        </>
      ) : (
        subtitle
      )}
    </Wrapper>
  );
};

const Wrapper = styled(Column).attrs({ align: "stretch" })<{
  $useUpdatedSpacing: boolean;
}>`
  align-self: stretch;
  padding: ${({ $useUpdatedSpacing }) => ($useUpdatedSpacing ? 0 : "0 0 2px")};
`;
